import { render, staticRenderFns } from "./NlModal.vue?vue&type=template&id=82722d36&scoped=true&"
import script from "./NlModal.vue?vue&type=script&lang=js&"
export * from "./NlModal.vue?vue&type=script&lang=js&"
import style0 from "./NlModal.vue?vue&type=style&index=0&id=82722d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82722d36",
  null
  
)

export default component.exports